import { SvgIconComponent } from "@material-ui/icons";
import classNames from "classnames";
import React from "react";

export const TimeTradeoffElementsWrap = ({
  icon: Icon,
  children,
  shouldCenterIcon = false,
}: {
  icon?: SvgIconComponent;
  children: React.ReactNode[];
  shouldCenterIcon?: boolean;
}) => {
  const icon = Icon ? <Icon className="cw-w-4 cw-h-4 cw-text-muted-disabled" aria-hidden /> : null;

  return (
    <div className="cw-flex-col cw-gap-4 cw-mx-3 cw-py-2 cw-body-base cw-border-b cw-border-solid last:cw-border-none cw-border-muted">
      <div
        className={classNames("cw-flex", {
          "cw-items-center cw-mb-1": shouldCenterIcon,
        })}
      >
        <div className="cw-mr-4">{icon}</div>
        <div className="cw-flex cw-flex-1">{children[0]}</div>
      </div>
      <div className="cw-flex cw-justify-start cw-mt-1">
        <div className="cw-w-8" />
        {children.slice(1, 2)}
      </div>
      <div className="cw-flex cw-justify-start cw-mt-1">
        <div className="cw-w-8" />
        {children.slice(2)}
      </div>
    </div>
  );
};
